import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { BYPASS_ERROR_NORMALIZATION } from '../services/http/http-context';
import { normaliseHttpError } from '../services/http/http-errors';

/**
 * Outermost interceptor: catches everything that surfaces from the network,
 * retry, and timeout layers and maps it to a closed set of domain error
 * types (`ApiError` | `NetworkError`). Service-layer code therefore never
 * sees raw `HttpErrorResponse` or `RxTimeoutError`.
 *
 * Callers that genuinely need the original error (e.g. for low-level
 * debugging) can opt out per-request with `BYPASS_ERROR_NORMALIZATION`.
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(BYPASS_ERROR_NORMALIZATION)) {
    return next(req);
  }
  return next(req).pipe(catchError(error => throwError(() => normaliseHttpError(error))));
};
